import { Component, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";

@Component({
    selector: "navbar-help",
    templateUrl: "./navbar-help.component.html",
    styleUrls: ["../navbar-plugin-base.scss", "./navbar-help.component.scss"]
})
export class NavbarHelpComponent {
    private _tabService = inject(TabService);
    private _pages = inject(Pages);


    openApiManuals() {
        this._tabService.generateTab(this._pages.Manuals);
    }

    openManuals() {
        window.open(this._pages.ManualsExternal, '_blank');
    }

    openReleaseNotes() {
        window.open(this._pages.ReleaseNotesExternal, '_blank');
    }

    openSupport() {
        window.open(this._pages.SupportExternal, '_blank');
    }

    openAbout() {
        this._tabService.generateTab(this._pages.About);
    }
}